import React, {useRef, useState} from 'react';
import {FaWandMagicSparkles} from "react-icons/fa6";
import Button from "../button/button.jsx";
import projectUtils from "../../utils/project-utils.js";
import axios from "axios";
import {Modal} from "../modal/modal.jsx";
import {diffWords} from "diff";
import {Card} from "../card/card.jsx";
import SImproveText from "../icons/improve-text.jsx";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const ReviseTextButton = ({value, setValue, setIsLoading, module = "Despacho"}) => {
    const [open, setOpen] = useState(false);

    const [textCorrection, setTextCorrection] = useState("")
    const [textDiff, setTextDiff] = useState(undefined);

    const card1Ref = useRef(null);
    const card2Ref = useRef(null);
    const isSyncing = useRef(false);

    const onClick = () => {
        if (!value || !value.length) {
            projectUtils.swalErrorMessage("", "Insira um texto.", "Ok");
            return;
        }

        if (setIsLoading) setIsLoading(true);

        axios.post(`${API_KEEPER}/api/text-correction`, {input: value, module}, {timeout: 120000})
            .then(({data}) => {
                setOpen(true);

                setTextCorrection(data.corrected_text);
                setTextDiff(diffWords(value, data.corrected_text));
            })
            .catch(error => {
                console.error(error);

                let message = 'Ocorreu um erro na requisição.';
                if (error.response.status !== 500) {
                    switch (error.response.data?.message) {
                        case "inputs.limit.exceeded": message = "Limite do servidor atingido."; break;
                        case "characters.not.exceeded": message = "O texto deve ter no mínimo 60 caracteres."; break;
                        default: message = 'Ocorreu um erro na requisição.';
                    }
                }

                projectUtils.swalErrorMessage('', message, 'Ok');
            })
            .finally(() => setIsLoading(false));
    }

    const apply = () => {
        axios.get(`${API_KEEPER}/api/text-correction/apply`);

        setValue(textCorrection);
        setOpen(false);
    }

    const syncScroll = (sourceRef, targetRef) => {
        if (!sourceRef.current || !targetRef.current || isSyncing.current) return;

        isSyncing.current = true;
        targetRef.current.scrollTop = sourceRef.current.scrollTop;

        window.requestAnimationFrame(() => {
            isSyncing.current = false;
        });
    };

    return (
        <>
            <Button target={"default"} onClick={onClick}>
                <SImproveText/> Melhorar e corrigir o texto
            </Button>

            <Modal open={open} setOpen={() => setOpen(false)} title={"Melhorar e corrigir o texto"} className={"w-8/12"} isCloseClick={false}>
                <Modal.Body className={"grid grid-cols-2 gap-3"}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Original</Card.Title>
                        </Card.Header>

                        <Card.Body className={"overflow-auto h-[35vh]"} ref={card1Ref} onScroll={() => syncScroll(card1Ref, card2Ref)}>
                            {textDiff?.filter(item => !item?.added).map((item, index) => item?.removed ? <span key={"text-" + index} style={{color: "salmon"}}>{item.value}</span> : item.value)}
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header>
                            <Card.Title>Corrigido</Card.Title>
                        </Card.Header>

                        <Card.Body className={"overflow-auto h-[35vh]"} ref={card2Ref} onScroll={() => syncScroll(card2Ref, card1Ref)}>
                            {textDiff?.filter(item => !item?.removed).map((item, index) => item?.added ? <span key={"text-" + index} style={{color: "forestgreen"}}>{item.value}</span> : item.value)}
                        </Card.Body>
                    </Card>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => apply()}>
                        Corrigir
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ReviseTextButton;